export default "__VITE_ASSET__DXu8nO7H__"